module.exports = {"id":"dp5_2l3q4","text":"Identifying Needs and Digital Technological Responses","instructions":"Digital assistance tools can support users but may also have limitations.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.2","questionType":"PickOne","random":false,"options":[{"id":"dp5_2l3q4-a1","text":"True","score":3.7},{"id":"dp5_2l3q4-a2","text":"Not Sure","score":1.3},{"id":"dp5_2l3q4-a3","text":"False","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.2/l3q4.json
// module id = 1310
// module chunks = 41